import { render, staticRenderFns } from "./trim.vue?vue&type=template&id=f7565bf0&"
import script from "./trim.vue?vue&type=script&lang=js&"
export * from "./trim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports